import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: './modules/shopping/shopping.module#ShoppingPageModule'
  },
  {
    path: 'shopping/food/cart',
    loadChildren: './modules/shopping/food/cart/cart.module#CartPageModule'
  },
  {
    path: 'shopping/retail/cart',
    loadChildren: './modules/shopping/retail/retail-cart/retail-cart.module#RetailCartPageModule'
  },
  {
    path: 'shopping/search',
    loadChildren: './modules/search/search.module#SearchPageModule'
  },
  {
    path: 'shopping/food/checkout',
    loadChildren: './modules/shopping/food/checkout/checkout.module#CheckoutPageModule'
  },
  {
    path: 'shopping/retail/checkout',
    loadChildren: './modules/shopping/food/checkout/checkout.module#CheckoutPageModule'
  },
  {
    path: 'shopping/food/checkout/confirmed',
    loadChildren: './modules/shopping/order-confirmed/order-confirmed.module#OrderConfirmedPageModule'
  },
  {
    path: 'shopping/retail/checkout/confirmed',
    loadChildren: './modules/shopping/order-confirmed/order-confirmed.module#OrderConfirmedPageModule'
  },
  {
    path: 'shopping/food/:storeName/:storeId',
    loadChildren: './modules/shopping/food/menu/menu.module#MenuPageModule'
  },
  {
    path: 'shopping/retail/product/:productId',
    loadChildren: './modules/shopping/retail/product-detail/product-detail.module#ProductDetailPageModule'
  },
  {
    path: 'shopping/retail/:storeName/:storeId',
    loadChildren: './modules/shopping/retail/retail-detail/retail-detail.module#RetailDetailPageModule'
  },
  {
    path: 'shopping/retail/products/:storeName/:storeId',
    loadChildren: './modules/shopping/retail/products-list/products-list.module#ProductsListPageModule'
  },
  {
    path: '**',
    redirectTo: '/shopping/retail',
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
